function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M79.3,8.1c-2.2,0-3.7-2-3.7-4.1c0-2.1,1.6-4.1,3.8-4.1s3.6,1.9,3.6,4.1C82.9,6.4,81.4,8.1,79.3,8.1z"
}), React.createElement("path", {
  d: "M103.5,18.5c-12.3,0-24,9.3-25.1,26.5h-0.1v22.3C78.3,82.1,78,94,62.6,95l0.6,2.8c2.8-0.1,9.5-1.5,13.2-5.7 c4.7-5.3,5.5-11.8,5.5-21.3V45.5H82c0.6-12.3,7.9-24,21.6-24c14.8,0,21.1,13.8,21.1,25.4c0,14.3-9,24.6-20.1,25.5v3 c11.2-0.8,23.8-9.5,23.8-28.9C128.4,30,118.6,18.5,103.5,18.5z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M206.1,45.5"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M247.2,45.5c0.1-0.5,0.1-1,0.1-1.7c0-0.4,0-0.8,0-1.2h-41.2v-0.5c0-21.3-13.1-23.6-17.6-23.6c-11.9,0-16.9,7.8-18.9,12.4 h-0.2c-2.1-7-8-12.4-15.6-12.4c-8.9,0-14.3,4.5-18,11.3h-0.2l-0.3-10.1h-3.5c0.3,4.2,0.4,7.6,0.4,12.3v42.2h3.6V40.4 c0-8.5,7.4-18.9,17.3-18.9c9.3,0,14.3,8,14.3,18.3v34.3h3.6V38.9c0-8.3,7.5-17.4,16.5-17.4c10.2,0,15.1,8,15.1,20.9v3.1L247.2,45.5z "
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.5,42.5h-44L29,44.6l0,0l-2.2,9.5l-3.6,15.3c-1.5-4.7-3.1-9-5.3-14.5L4.3,19.7H0l21.7,54.5h3l7.3-28.6h0.4c0,0,0,0,0,0 h40.9c0.1-0.5,0.1-1,0.1-1.7C73.5,43.4,73.5,42.9,73.5,42.5z"
});

var SvgLogoVejome = function SvgLogoVejome(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 247.3 97.8",
    style: {
      enableBackground: "new 0 0 247.3 97.8"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/logo_vejome.5a623874.svg";
export { SvgLogoVejome as ReactComponent };